import { getCategoryFallback } from "@/lib/resolveRecipeImage";

/**
 * Capa da receita sem foto.
 *
 * Antes: gradiente de cor crua + dois emoji sobrepostos + o título em 10px.
 * Nada disso existe no app — a régua não tem 10px, o app tem uma cor de
 * marca só, e emoji não é ícone. Sobrou o que a capa precisa ser: um bloco
 * neutro em hsl(var(--muted)) com um ícone de traço discreto da categoria.
 *
 * O título continua aparecendo no cartão que envolve a capa, então repetir
 * ele aqui seria a segunda informação da mesma linha. `title` fica só como
 * texto acessível da capa.
 */
const RecipeFallbackCover = ({
  title,
  category,
  className = "",
  iconSize = 24,
}: {
  title: string;
  category?: string | null;
  className?: string;
  /** 24px cabe na menor capa em uso (48px) sem encostar na borda; a foto grande do detalhe passa mais. */
  iconSize?: number;
}) => {
  const { icon: Icon } = getCategoryFallback(category);

  return (
    <div
      className={`${className} bg-muted flex items-center justify-center`}
      role="img"
      aria-label={title}
    >
      <Icon
        size={iconSize}
        strokeWidth={1.5}
        aria-hidden="true"
        // --tinta-fraca é o teto do que pode ficar apagado: isto é decoração
        // de fundo, não informação que alguém precisa ler.
        style={{ color: "var(--tinta-fraca)" }}
      />
    </div>
  );
};

export default RecipeFallbackCover;
